// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__1Lhqn","links":"Contact_links__2g5HU"};